/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

import { INavigationProps } from "./INavigationProps";
import { AdminNavbar, AdminNavBrand, AdminNavLink } from "./Navigation.styles";

const Navigation = ({
  isUserAuthenticated,
  onSignInClicked,
  onSignOutClicked,
}: INavigationProps): ReactElement => {
  const renderSignIn = (): ReactElement => {
    if (isUserAuthenticated) {
      return (
        <AdminNavLink key="signout" id="sign-out" onClick={onSignOutClicked}>
          Sign Out
        </AdminNavLink>
      );
    } else {
      return (
        <AdminNavLink key="signin" id="sign-in" onClick={onSignInClicked}>
          Sign In
        </AdminNavLink>
      );
    }
  };

  return (
    <AdminNavbar expand="lg">
      <Navbar.Brand href="https://www.microsoft.com/">
        <img
          src="/microsoft-logo.png"
          alt="Microsoft - Official Home Page"
          title="Microsoft - Official Home Page"
          className="mscom-siteLogo"
        />
      </Navbar.Brand>
      <AdminNavBrand to="" as={Link}>
        <span className="mscom-divider">&#124;</span>
        <span>MVP Communities Admin Center</span>
      </AdminNavBrand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Item>{renderSignIn()}</Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </AdminNavbar>
  );
};

export default Navigation;
